<template>
  <b-card>
    <template #header>
      <h3>
        Proposal Form -
        <strong class="text-danger"> {{ $store.state.app.pageTitle }} </strong>
      </h3>
    </template>
    <b-form @submit.prevent="() => create().finally(() => (isLoading = false))">
      <b-row>
        <b-col cols="12">
          <b-form-group label-for="judul">
            <template slot="label">
              <span>Judul <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="judul" v-model="form.title" required />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label-for="perusahaan">
            <template slot="label">
              <span>Perusahaan <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input
              id="perusahaan"
              v-model="form.company_name"
              required
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label-for="alamatperusahaan">
            <template slot="label">
              <span
                >Alamat Perusahaan <strong class="text-danger">*</strong></span
              >
            </template>
            <b-form-input
              id="alamatperusahaan"
              v-model="form.company_address"
              required
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label-for="namapic">
            <template slot="label">
              <span>Nama PIC <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="namapic" v-model="form.pic_name" required />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label-for="jabatanpic">
            <template slot="label">
              <span>Jabatan PIC <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="jabatanpic" v-model="form.pic_jabatan" required />
          </b-form-group>
        </b-col>

        <b-col cols="12" sm="12" lg="6">
          <b-form-group label-for="product">
            <template slot="label">
              <span
                >Company Profile <strong class="text-danger">*</strong></span
              >
            </template>
            <v-select
              v-model="form.company_profile"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="['Yes', 'No']"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12" lg="6">
          <b-form-group>
            <template slot="label">
              <span
                >Start Date Periode <strong class="text-danger">*</strong></span
              >
            </template>
            <flat-pickr
              v-model="form.start_date"
              class="form-control"
              :config="{ enableTime: false, dateFormat: 'Y-m-d H:i' }"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12" lg="6">
          <b-form-group>
            <template slot="label">
              <span
                >End Date Periode<strong class="text-danger">*</strong></span
              >
            </template>
            <flat-pickr
              v-model="form.end_date"
              class="form-control"
              :config="{ enableTime: false, dateFormat: 'Y-m-d H:i' }"
            />
          </b-form-group>
        </b-col>
        <b-col cols="11" class="pr-0">
          <b-form-group label-for="pernawaranharga">
            <template slot="label">
              <span
                >Penawaran harga <strong class="text-danger">*</strong></span
              >
            </template>
            <b-form-file
              v-model="form.penawaran_harga"
              size="sm"
              required
            ></b-form-file>
          </b-form-group>
        </b-col>
        <b-col cols="1" class="pl-0">
          <b-form-group label-for="pernawaranharga">
            <template slot="label">
              <span class="text-white">|</span>
            </template>
            <b-link
              :to="{
                name: 'product-calculator',
                params: { kode: $route.params.id },
              }"
              target="_blank"
            >
              <b-button variant="outline-secondary" size="sm">
                Calculator
              </b-button>
            </b-link>
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label-for="description">
            <template slot="label">
              <span
                >Lingkup Pekerjaan <strong class="text-danger">*</strong></span
              >
            </template>
            <snote ref="snote" v-model="form.lingkup_pekerjaan" />
            <!-- <quill-editor
              v-model="form.description"
              id="description"
              :options="editorOption"
            /> -->
          </b-form-group>
        </b-col>
        <!-- 
        <b-col sm="12">
          <b-form-group label="Lampiran" label-for="dropzone-lampiran">
            <div id="dropzone-lampiran" class="dropzone dropzone-area mb-3">
              <div class="dz-message">
                Drop files here or click button to upload. <br />(Max. size 2MB)
              </div>
            </div>
          </b-form-group>
        </b-col> -->
        <b-col cols="12">
          <b-form-group label-for="">
            <template slot="label">
              <span>Lampiran <strong class="text-danger">*</strong></span>
            </template>
            <b-form-file
              v-model="form.lampiran"
              size="sm"
              required
            ></b-form-file>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label-for="namaam">
            <template slot="label">
              <span>Nama AM <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="namaam" v-model="form.am_name" required />
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label-for="nikam">
            <template slot="label">
              <span>NIK AM <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="nikam" v-model="form.am_nik" required />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label-for="jabatanam">
            <template slot="label">
              <span>Jabatan AM <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="jabatanam" v-model="form.am_jabatan" required />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label-for="notelpam">
            <template slot="label">
              <span>No Telp AM <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="notelpam" v-model="form.am_phone" required />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label-for="emailam">
            <template slot="label">
              <span>Email AM <strong class="text-danger">*</strong></span>
            </template>
            <b-form-input id="emailam" v-model="form.am_email" required />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group class="d-flex justify-content-end">
            <b-button
              :to="{
                name: 'product-proposal-index',
                params: { id: $route.params.id },
                query: { from: $route.query.from },
              }"
              variant="light"
              class="mr-1"
            >
              Cancel
            </b-button>
            <b-button
              :disabled="isLoading"
              type="submit"
              variant="primary"
              class="mr-1"
            >
              Save
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
  BFormSelect,
  BFormSelectOption,
  BButton,
  BFormTextarea,
  BFormFile,
  BLink,
} from 'bootstrap-vue'
import { quillEditor } from 'vue-quill-editor'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import snote from '@/views/admin/product/summernote.vue'
import toastification from '@/libs/toastification'
import router from '@/router'
import * as ProposalService from './service.js'

export default {
  components: {
    BCard,
    BForm,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BFormSelect,
    BFormSelectOption,
    quillEditor,
    BButton,
    BFormTextarea,
    BFormFile,
    flatPickr,
    vSelect,
    BLink,
    snote,
  },
  setup() {
    const { createProposal } = ProposalService
    const { form, create: createAction, isLoading } = createProposal()
    const create = async () => {
      return await createAction()
        .then(res => {
          toastification.notif(
            'Success',
            'Product Proposal has been successfully created.',
            'success'
          )
          router.push({
            name: 'product-proposal-index',
            params: { id: form.value.product_kode },
            query: { from: router.currentRoute?.query?.from },
          })
        })
        .catch(err => {
          console.error(err)
          toastification.notif('Error', 'Something error', 'danger')
        })
    }
    return {
      form,
      create,
      isLoading,
    }
  },
  data() {
    return {
      dzLampiran: null,
    }
  },

  mounted() {
    this.form.product_kode = this.$route.params.id
  },
  methods: {
    initDropzone() {
      const vm = this
      const options = {
        url: `${process.env.VUE_APP_API_URL}/dummy`,
        maxFiles: 1,
        autoProcessQueue: true,
        autoQueue: true,
        addRemoveLinks: true,
        maxFilesize: 200,
        accept(file, done) {
          file.accepted = true
          file.status = 'success'
          this.emit('success', file)
          this.emit('complete', file)
        },
      }
      this.dzLampiran = new window.Dropzone('#dropzone-lampiran', options)
    },
  },
}
</script>

<style scoped>
deep .dropzone {
  min-height: 200px;
}
deep .dz-message:before {
  display: none;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
